import { useContextController } from "context";
import { PropsWithChildren, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CanAccess } from "types";
import Unauthorized from "./Unauthorized";
import UserLayout from "./UserLayout";

interface IPrivateLayout extends PropsWithChildren {
  canAccess: CanAccess;
}

export default function PrivateLayout({ children, canAccess }: IPrivateLayout) {
  const [{ userData, loadingUser }] = useContextController();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loadingUser && !userData) {
      if (typeof localStorage !== "undefined" && localStorage.getItem("logout") !== null) {
        localStorage.removeItem("logout");
      }
      navigate("/login");
    }
  }, [userData, loadingUser, navigate]);

  return (
    <UserLayout>
      {!loadingUser && userData && !canAccess(userData.type, userData.role) ? <Unauthorized /> : children}
    </UserLayout>
  );
}
